import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { PlpCategoryQuicklinksBlockComponent } from './plp-category-quicklinks.component';

@Component({
    selector: 'plp-category-quicklinks-layout',
    template: '<plp-category-quicklinks></plp-category-quicklinks>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [PlpCategoryQuicklinksBlockComponent]
})
@ICmsComponent<PlpCategoryQuicklinksLayoutComponent>({
    id: 'plp-category-quicklinks-layout',
    name: 'Plp Category Quicklinks Layout',
    tags: ['Category', 'Quicklinks'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label',
            title: 'Please edit content block inside this component'
        },
    ]
})
export class PlpCategoryQuicklinksLayoutComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NICmsContentComponent.IData;
}
